import styled from 'styled-components';

// common component
import LoadingCircle from '@src/components/common/LoadingCircle';

const EmptyPage = () => (
  <FallbackContainer className="EmptyPage__FallbackContainer">
    <FallbackLoadingCircleWrap className="EmptyPage__FallbackLoadingCircleWrap">
      <FallbackLoadingCricle
        className="EmptyPage__FallbackLoadingCricle"
        viewBox="0 0 80 80"
        isLoading
      />
    </FallbackLoadingCircleWrap>
  </FallbackContainer>
);

// 로그인 로딩
const FallbackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 0 0 100vh;
  overflow: hidden;
  filter: blur(3px);
`;

const FallbackLoadingCircleWrap = styled.div`
  text-align: center;
  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    width: 80%;
  }
`;
const FallbackLoadingCricle = styled(LoadingCircle)`
  width: 100%;
`;

export default EmptyPage;
